import { NEXT_PLANNED_DELIVERY_RECEIVE, NEXT_PLANNED_DELIVERY_LOADING } from '../Actions/NextPlannedDelivery.action';

export const nextPlannedDelivery = (state = { }, action) => {
    switch (action.type) {
        case NEXT_PLANNED_DELIVERY_RECEIVE:
            return {
                ...state,
                ...action.payload,
            };
        default:
            return state;
    }
}